import React from 'react';
import { render } from 'react-dom';
import { Router, Switch, Route } from 'react-router-dom';
import history from './history';
import App from './components/App';
import Register from './components/Register';
import BuyCredits from './components/BuyCredits';
import Login2 from './components/Login2';
import Login from './components/Login';
import Login3 from './components/Login3';
import LoginFace3 from './components/LoginFace3';
import Login4 from './components/Login4';
import Login5 from './components/Login5';
import Login6 from './components/Login6';
import Login7 from './components/Login7';
import Login8 from './components/Login8';
import Login9 from './components/Login9';
import Login10 from './components/Login10';
import Login11 from './components/Login11';
import Login12 from './components/Login12';
import OTPAuthentication from './components/OTPAuthentication';
import TokenAuthentication from './components/TokenAuthentication';
import DirectTokenVerification from './components/DirectTokenVerification';
import ShowTokens from './components/ShowTokens';
import SearchEngine from './components/SearchEngine';
import LoginCredits100 from './components/LoginCredits100';
import LoginCredits300 from './components/LoginCredits300';
import LoginCredits500 from './components/LoginCredits500';
import LoginCredits1000 from './components/LoginCredits1000';
import LoginCredits2000 from './components/LoginCredits2000';
import LoginCredits5000 from './components/LoginCredits5000';
import LoginCredits10000 from './components/LoginCredits10000';
import PaymentQR100 from './components/PaymentQR100';
import PaymentQR300 from './components/PaymentQR300';
import PaymentQR500 from './components/PaymentQR500';
import PaymentQR1000 from './components/PaymentQR1000';
import PaymentQR2000 from './components/PaymentQR2000';
import PaymentQR5000 from './components/PaymentQR5000';
import PaymentQR10000 from './components/PaymentQR10000';
import CoinsOptions from './components/CoinsOptions';
import UploadSlip100 from './components/UploadSlip100';
import UploadSlip300 from './components/UploadSlip300';
import UploadSlip500 from './components/UploadSlip500';
import UploadSlip1000 from './components/UploadSlip1000';
import UploadSlip2000 from './components/UploadSlip2000';
import UploadSlip5000 from './components/UploadSlip5000';
import UploadSlip10000 from './components/UploadSlip10000';
import ClaimCredits100 from './components/ClaimCredits100';
import ClaimCredits300 from './components/ClaimCredits300';
import ClaimCredits500 from './components/ClaimCredits500';
import ClaimCredits1000 from './components/ClaimCredits1000';
import ClaimCredits2000 from './components/ClaimCredits2000';
import ClaimCredits5000 from './components/ClaimCredits5000';
import ClaimCredits10000 from './components/ClaimCredits10000';
import ImageConverter from './components/ImageConverter';
import UploadImage from './components/UploadImage';
import HashPDF from './components/HashPDF';
import PdfHash from './components/PdfHash';
import ThaiOCR from './components/ThaiOCR';
import IDOCR from './components/IDOCR';
import WebcamCapture from './components/WebcamCapture';
import VerifyDoc from './components/VerifyDoc';
import Transition from './components/Transition';
import QRCodeGenerator from './components/QRCodeGenerator';
import CamSlipcheck from './components/CamSlipcheck';
import VerifySlipOptions from './components/VerifySlipOptions';
import FaceRegister from './components/FaceRegister';
import FaceValidation from './components/Facevalidation';
import StripePage100 from './components/StripePage100';
import StripePage300 from './components/StripePage300';
import StripePage500 from './components/StripePage500';
import StripePage1000 from './components/StripePage1000';
import StripePage2000 from './components/StripePage2000';
import StripePage5000 from './components/StripePage5000';
import StripePage10000 from './components/StripePage10000';
import StripeQR100 from './components/StripeQR100';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentMethods from './components/PaymentMethods';
import CreditcardOptions from './components/CreditcardOptions';
import VerifySlipx from './components/VerifySlipx';
import ForgetPassword from './components/ForgetPassword';
import ResetPassword from './components/ResetPassword';
import CryptoPay from './components/CryptoPay';
import CryptoOptions from './components/CryptoOptions';


import './index.css';

render(
  <Router history={history}>
    <Switch>
      <Route exact path='/' component={App} />
      <Route path='/register' component={Register} />
      <Route path='/buycredits' component={BuyCredits} />
      <Route path='/login2' component={Login2} />
      <Route path='/login' component={Login} />
      <Route path='/login3' component={Login3} />
      <Route path='/loginface3' component={LoginFace3} />
      <Route path='/login4' component={Login4} />
      <Route path='/login5' component={Login5} />
      <Route path='/login6' component={Login6} />
      <Route path='/login7' component={Login7} />
      <Route path='/login8' component={Login8} />
      <Route path='/login9' component={Login9} />
      <Route path='/login10' component={Login10} />
      <Route path='/login11' component={Login11} />
      <Route path='/login12' component={Login12} />
      <Route path='/logincredits100' component={LoginCredits100} />
      <Route path='/logincredits300' component={LoginCredits300} />
      <Route path='/logincredits500' component={LoginCredits500} />
      <Route path='/logincredits1000' component={LoginCredits1000} />
      <Route path='/logincredits2000' component={LoginCredits2000} />
      <Route path='/logincredits5000' component={LoginCredits5000} />
      <Route path='/logincredits10000' component={LoginCredits10000} />
      <Route path='/showtokens' component={ShowTokens} />
      <Route path='/tokenauthentication' component={TokenAuthentication} />
      <Route path='/directtokenverification' component={DirectTokenVerification} />
      <Route path='/searchengine' component={SearchEngine} />
      <Route path='/otptest' component={OTPAuthentication} />
      <Route path='/paymentqr100' component={PaymentQR100} />
      <Route path='/paymentqr300' component={PaymentQR300} />
      <Route path='/paymentqr500' component={PaymentQR500} />
      <Route path='/paymentqr1000' component={PaymentQR1000} />
      <Route path='/paymentqr2000' component={PaymentQR2000} />
      <Route path='/paymentqr5000' component={PaymentQR5000} />
      <Route path='/paymentqr10000' component={PaymentQR10000} />
      <Route path='/coinsoptions' component={CoinsOptions} />
      <Route path='/uploadslip100' component={UploadSlip100} />
      <Route path='/uploadslip300' component={UploadSlip300} />
      <Route path='/uploadslip500' component={UploadSlip500} />
      <Route path='/uploadslip1000' component={UploadSlip1000} />
      <Route path='/uploadslip2000' component={UploadSlip2000} />
      <Route path='/uploadslip5000' component={UploadSlip5000} />
      <Route path='/uploadslip10000' component={UploadSlip10000} />
      <Route path='/verifyslipx' component={VerifySlipx} />
      <Route path='/claimcredits100' component={ClaimCredits100} />
      <Route path='/claimcredits300' component={ClaimCredits300} />
      <Route path='/claimcredits500' component={ClaimCredits500} />
      <Route path='/claimcredits1000' component={ClaimCredits1000} />
      <Route path='/claimcredits2000' component={ClaimCredits2000} />
      <Route path='/claimcredits5000' component={ClaimCredits5000} />
      <Route path='/claimcredits10000' component={ClaimCredits10000} />
      <Route path='/imageconverter' component={ImageConverter} />
      <Route path='/uploadimage' component={UploadImage} />
      <Route path='/hashpdf' component={HashPDF} />
      <Route path='/pdfhash' component={PdfHash} />
      <Route path='/thaiocr' component={ThaiOCR} />
      <Route path='/idocr' component={IDOCR} />
      <Route path='/webcamcapture' component={WebcamCapture} />
      <Route path='/verifydoc' component={VerifyDoc} />
      <Route path='/transition' component={Transition} />
      <Route path='/qrcodegenerator' component={QRCodeGenerator} />
      <Route path='/camslipcheck' component={CamSlipcheck} />
      <Route path='/verifyslipoptions' component={VerifySlipOptions} />
      <Route path='/faceregister' component={FaceRegister} />
      <Route path='/facevalidation' component={FaceValidation} />
      <Route path='/creditcard100' component={StripePage100} />
      <Route path='/creditcard300' component={StripePage300} />
      <Route path='/creditcard500' component={StripePage500} />
      <Route path='/creditcard1000' component={StripePage1000} />
      <Route path='/creditcard2000' component={StripePage2000} />
      <Route path='/creditcard5000' component={StripePage5000} />
      <Route path='/creditcard10000' component={StripePage10000} />
      <Route path='/stripeqr100' component={StripeQR100} />
      <Route path='/paymentsuccess' component={PaymentSuccess} />
      <Route path='/paymentmethods' component={PaymentMethods} />
      <Route path='/creditcardoptions' component={CreditcardOptions} />
      <Route path='/forgetpassword' component={ForgetPassword} />
      <Route path='/resetpassword' component={ResetPassword} />
      <Route path='/cryptopay' component={CryptoPay} />
      <Route path='/cryptooptions' component={CryptoOptions} />


    </Switch>
  </Router>,
  document.getElementById('root')
);

// Splash screen (in index.html) fades itself out with CSS after ~1s, so it never waits
// for this 3MB bundle to download. Here we only remove it from the DOM.
const splash = document.getElementById('splash');
if (splash) setTimeout(() => splash.remove(), Math.max(0, 1200 - performance.now()));

// PWA: sw.js is copied unbundled into client/dist by the build script.
// The URL lives in a variable so Parcel doesn't try to bundle it.
if ('serviceWorker' in navigator) {
  const swUrl = '/sw.js';
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(swUrl).catch((err) => console.warn('SW registration failed', err));
  });
}
